/* ============================================================
   <sw-load-more> — generic Load More CTA
   ============================================================
   Reveals the next batch of `data-batch-size` hidden cards inside
   the element targeted by `data-target` (a CSS selector).

   Markup contract:
     <sw-load-more data-target="#Slider-XYZ" data-batch-size="5">
       <button>Load More</button>
     </sw-load-more>

   The grid contains items, with cards beyond the initial batch
   tagged with `.sw-fp__hidden` (display: none). Each click removes
   the hidden class from up to `batch-size` items. When no hidden
   items remain, the component hides itself.
   ============================================================ */
class SwLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.targetSelector = this.dataset.target;
    this.batchSize = parseInt(this.dataset.batchSize, 10) || 5;
    this.hiddenClass = this.dataset.hiddenClass || 'sw-fp__hidden';

    if (!this.button || !this.targetSelector) return;

    this._onClick = this._onClick.bind(this);
    this.button.addEventListener('click', this._onClick);

    this._syncVisibility();
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this._onClick);
  }

  _onClick() {
    const target = document.querySelector(this.targetSelector);
    if (!target) return;
    const hidden = target.querySelectorAll('.' + this.hiddenClass);
    for (let i = 0; i < this.batchSize && i < hidden.length; i++) {
      hidden[i].classList.remove(this.hiddenClass);
    }
    this._syncVisibility();
  }

  _syncVisibility() {
    const target = document.querySelector(this.targetSelector);
    if (!target) return;
    const remaining = target.querySelectorAll('.' + this.hiddenClass).length;
    if (remaining === 0) this.style.display = 'none';
  }
}

if (!customElements.get('sw-load-more')) {
  customElements.define('sw-load-more', SwLoadMore);
}
